import { render } from "./BaseRelatorio.vue?vue&type=template&id=06bcb30a"
import script from "./BaseRelatorio.vue?vue&type=script&lang=js"
export * from "./BaseRelatorio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__